<template>
    <!-- <v-navigation-drawer permanent expand-on-hover app  dense>     -->
    <v-navigation-drawer app temporary dense disable-resize-watcher v-model="esVisible" color="claro">
    <!-- <v-navigation-drawer permanent app dense>     -->
        <v-list>
          <v-list-item class="px-2">
            <v-list-item-avatar>
              <v-img src="../assets/venado-avatar.png"></v-img>
            </v-list-item-avatar>
          </v-list-item>
        
        </v-list>

       
        <v-list nav dense>
          <v-divider></v-divider>
          <span class="primary--text"><b>Alumnos</b></span>
          <v-list-item link to="/AdminComiteAcademico">
            <v-list-item-icon>
              <v-icon color="green">mdi-human-capacity-increase</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="oscuro--text">Comité Académico</v-list-item-title>
          </v-list-item>

          <v-list-item link to="/AdminTraslado" >
            <v-list-item-icon>
              <v-icon color="green">mdi-transit-transfer</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="oscuro--text">Traslado Estudiantil</v-list-item-title>
          </v-list-item>

          <v-list-item link>
            <v-list-item-icon>
              <v-icon color="green">mdi-compass</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="oscuro--text">Cambio de carrera</v-list-item-title>
          </v-list-item>

          <v-list-item link>
            <v-list-item-icon>
              <v-icon color="green">mdi-bank-transfer</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="oscuro--text">Movilidad</v-list-item-title>
          </v-list-item>

          <v-list-item link>
            <v-list-item-icon>
              <v-icon color="green">mdi-calendar-check</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="oscuro--text">Actividad complementaria</v-list-item-title>
          </v-list-item>

        <v-divider></v-divider>
        <span class="primary--text"><b>Servicios</b></span>
          <v-list-item link to="/adminserviciosrequeridos">
            <v-list-item-icon>
              <v-icon color="warning">mdi-text-box-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="oscuro--text">Servicios requeridos</v-list-item-title>
          </v-list-item>


          <v-list-item link to="/adminpsp">
            <v-list-item-icon>
              <v-icon color="warning">mdi-account-hard-hat-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="oscuro--text">Prestadores de servicios</v-list-item-title>
          </v-list-item>

          <v-list-item link to="/admincontratos">
            <v-list-item-icon>
              <v-icon color="warning">mdi-file-sign</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="oscuro--text">Contratos</v-list-item-title>
          </v-list-item>
          
        
      <v-divider></v-divider>
        <span class="primary--text"><b>Usuarios</b></span>
          
          <v-list-item link to="/adminusuarios">
            <v-list-item-icon>
              <v-icon color="primary">mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="oscuro--text">Nuevo</v-list-item-title>
          </v-list-item>

      <v-divider></v-divider>
        <span class="primary--text"><b>Configuración</b></span>
          
          <v-list-item link to="/parametrosespeciales">
            <v-list-item-icon>
              <v-icon color="secondary">mdi-cog-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="oscuro--text">Parámetros especiales</v-list-item-title>
          </v-list-item>

        </v-list>
    </v-navigation-drawer>
</template>


<script>
export default {
    name: 'MenuLateralAdmin',
    props:{
      value: Boolean
    },   
    data() {
        return {
            esVisible: this.value,
            
            nombre: "Fredy",
            apellido: "Ponce",
            correo: "fredyitp@gmail.com",
        }
    },   

    watch:{
      value: function(){
        this.esVisible = this.value
      },
      esVisible: function() {
        this.$emit('cerrar', this.esVisible)
      }  

    },

    methods: {
        traslado(){
          this.$router.push({name: 'AdminTraslado'})
        }
    },
}
</script>
